import React from "react";
import { Link } from 'gatsby';

const Footer = () => {
  return ( 
<footer className="bg-gray-900">
  <div className="mx-auto max-w-7xl px-6 pb-8 pt-16 sm:pt-24 lg:px-8 lg:pt-32">
    <div className="xl:grid xl:grid-cols-3 xl:gap-8">
      <div className="space-y-8">
        <img className="h-9" src="/images/footer-logo.svg" alt="Sorry™" />
      </div>
      <div className="mt-16 grid grid-cols-2 gap-8 xl:col-span-2 xl:mt-0">
        <div className="md:grid md:grid-cols-2 md:gap-8">
          <div>
            <h3 className="text-sm font-semibold text-white">Getting Started</h3>
            <ul  className="mt-6 space-y-4">
              <li>
                <Link to="/pricing" className="text-sm text-gray-400 hover:text-white">Pricing</Link>
              </li>
              <li>
                <a href="https://app.sorryapp.com/people/sign_up?plan=price_0QSH3a596061iK2wzf4dPxQ4&subscribers=1000&pages=1&privacy=false" className="text-sm text-gray-400 hover:text-white">Start a free trial</a>
              </li>
              <li>
                <Link to="/demo" className="text-sm text-gray-400 hover:text-white">Get a demo</Link>
              </li>
            </ul>
          </div>
          <div className="mt-10 md:mt-0">
            <h3 className="text-sm font-semibold text-white">Status Pages</h3>
            <ul  className="mt-6 space-y-4">
              <li>
                <Link to="/public-status-page/" className="text-sm text-gray-400 hover:text-white">Public Status Pages</Link>
              </li>
              <li>
                <Link to="/private-status-page/" className="text-sm text-gray-400 hover:text-white">Private Status Pages</Link>
              </li>
              <li>
                <Link to="/integrations/status-badge/" className="text-sm text-gray-400 hover:text-white">Status Badge</Link>
              </li>
              <li>
                <Link to="/integrations/" className="text-sm text-gray-400 hover:text-white">Integrations</Link>
              </li>
              <li>
                <Link to="/status-api/" className="text-sm text-gray-400 hover:text-white">Status API</Link>
              </li>
              <li>
                <a href="https://docs.sorryapp.com" target="_blank" rel="noreferrer" className="text-sm text-gray-400 hover:text-white">REST API</a>
              </li>
            </ul>
          </div>
        </div>
        <div className="md:grid md:grid-cols-2 md:gap-8">
          <div>
            <h3 className="text-sm font-semibold text-white">Use Cases</h3>
            <ul  className="mt-6 space-y-4">
              <li>
                <Link to="/notices/incidents" className="text-sm text-gray-400 hover:text-white">Incidents</Link>
              </li>
              <li>
                <Link to="/notices/maintenance" className="text-sm text-gray-400 hover:text-white">Maintenance</Link>
              </li>
              <li>
                <Link to="/notices/general" className="text-sm text-gray-400 hover:text-white">Change Log</Link>
              </li>
            </ul>
          </div>
          <div className="mt-10 md:mt-0">
          <h3 className="text-sm font-semibold text-white">Resources</h3>
          <ul  className="mt-6 space-y-4">
              <li>
                <Link to="/incident-communications-101/" className="text-sm text-gray-400 hover:text-white">eBook: Incident Communication 101</Link>
              </li>
              <li>
              <a href="https://status.sorryapp.com/history?filter%5Btags_name_cont%5D=Changelog" target="_blank" rel="noreferrer" className="text-sm text-gray-400 hover:text-white">Product Updates</a>
              </li>
              <li>
                <Link to="/security-and-performance/" className="text-sm text-gray-400 hover:text-white">Security</Link>
              </li>
              <li>
                <Link to="/blog/" className="text-sm text-gray-400 hover:text-white">Blog</Link>
              </li>
              <li>
              <a href="https://status.sorryapp.com" target="_blank" rel="noreferrer" className="text-sm text-gray-400 hover:text-white"><img src="https://status.sorryapp.com/badge.svg" alt="Icon showing our current status." className="h-6 w-6 float-left -ml-1 mr-1" />Status</a>
              </li>
          </ul>
          </div>
        </div>
      </div>
    </div>
    <div className="mt-16 border-t border-white/10 pt-8 sm:mt-20 flex flex-col gap-6 md:flex-row md:gap-8">
      <ul className="flex flex-col md:flex-row gap-2 md:gap-4 leading-5 text-xs leading-5">
        <li>
          <Link to="/privacy-policy" className="text-gray-500 hover:text-gray-400">Privacy Policy</Link>
        </li>
        <li>
          <Link to="/cookie-policy" className="text-gray-500 hover:text-gray-400">Cookie Policy</Link>
        </li>
        <li>
          <Link to="/terms-of-service" className="text-gray-500 hover:text-gray-400">Terms of Service</Link>
        </li>
        <li>
          <a href="https://drive.google.com/file/d/1lWDyNWN8V9uYFku71cLg6TVJXO2bnk9a/view?usp=drive_link" target="_blank" rel="noreferrer" className="text-gray-500 hover:text-gray-400">Data Processing Agreement</a>
        </li>
         <li>
          <Link to="/acceptable-use-policy" className="text-gray-500 hover:text-gray-400">Acceptable Use Policy</Link>
        </li>         
      </ul>
      <p className="text-xs leading-5 text-gray-400 sm:order-first">&copy; {new Date().getFullYear()} SorryApp LTD</p>
    </div>
  </div>
</footer>
   );
}
 
export default Footer;